import React, { memo, useCallback, useState } from 'react';
import AnimatedSlide, { AnimatedSlideTemplate } from './AnimatedSlide';
import AnimateSliderBullets from './AnimatedSliderBullets';
import classNames from 'classnames';
import { Button } from '@components/tailwind';

type Props = {
  slides: any[];
  id: string;
  className?: string;
  sliderTitle?: string;
  sliderBottomNote?: string;
};

const AnimatedSlider = ({ slides, id, className = '', sliderTitle, sliderBottomNote }: Props) => {
  const [activeSlide, setActiveSlide] = useState(0);

  const onSlideNavigateHandler = useCallback(
    (nextSlide) => () => setActiveSlide(nextSlide),
    [id]
  );

  const slidesCount = slides?.length ?? 0;
  const onNextClick = onSlideNavigateHandler(activeSlide + 1 === slidesCount ? 0 : activeSlide + 1);
  const onPrevClick = onSlideNavigateHandler(activeSlide === 0 ? slidesCount - 1 : activeSlide - 1);

  if (slidesCount === 0) return null;

  return (
    <>
      <div id={id} className={classNames('!tw-my-10 tw-mx-auto tw-max-w-[1440px]', className)}>
        {slides.map((slide, idx) => (
          <AnimatedSlide
            onNextClick={onNextClick}
            onPrevClick={onPrevClick}
            key={idx}
            slide={slide}
            sliderTitle={sliderTitle}
            sliderBottomNote={sliderBottomNote}
            isActive={idx === activeSlide}
            sliderBulletsComp={
              slides.length > 1 && (
                <AnimateSliderBullets
                  count={slides.length}
                  activeSlide={activeSlide}
                  onNextClick={onNextClick}
                  onPrevClick={onPrevClick}
                  onBulletClick={(idx) => onSlideNavigateHandler(idx)}
                />
              )
            }
            appendImageContentSlide={
              id === 'TechAndFeatures' &&
              slides.findIndex((s) => s.template === AnimatedSlideTemplate.ITEMS_LIST) > 0 && (
                <Button
                  onClick={onSlideNavigateHandler(slidesCount - 1)}
                  variant='link'
                  className='tw-mt-10 !tw-px-0'
                  size='lg'>
                  See Full List of Features
                </Button>
              )
            }
          />
        ))}
      </div>
    </>
  );
};

export default memo(AnimatedSlider);
